"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const join_1 = __importDefault(require("../util/join"));
function Join(_a) {
    var { react, separator, children, rootComponent } = _a, props = __rest(_a, ["react", "separator", "children", "rootComponent"]);
    const joinedChildren = react.useMemo(() => (0, join_1.default)(children.filter(Boolean).map((node, index) => {
        var _a;
        // wrap each element in a fragment, so that it can be guaranteed to have a key
        return react.createElement(react.Fragment, {
            key: (_a = node === null || node === void 0 ? void 0 : node.key) !== null && _a !== void 0 ? _a : index,
        }, node);
    }), (child, index) => react.createElement(separator, {
        key: `separator-${index}`,
    })), [children]);
    return react.createElement((rootComponent !== null && rootComponent !== void 0 ? rootComponent : react.Fragment), props, joinedChildren);
}
exports.default = Join;
